import(/* webpackMode: "eager" */ "/app/src/app/(compass)/home/dashboard/credit-score/page.tsx");
